import {
  mapState,
  mapActions,
  mapMutations
} from 'vuex'

export default {
  computed: {
    ...mapState({
      Common: 'Commom',
      UserManagement: 'UserManagement',
      leftMenuShow:'leftMenuShow',
      docFontSize:'fontSize',
    })
  },
  methods: {
    ...mapMutations({
      setLeftMenuShow_M:'SET_LEFTMENU_SHOW',
      setLeftMenuIndex_M:"SET_LEFTMENU_INDEX",
    }),
    ...mapActions({
      findUserList: 'UserManagement/findUserList',
      findById: 'UserManagement/findById'
    })

  }

}



// WEBPACK FOOTER //
// ./src/pages/PartII/UserManagement/components/Mixins.js